module.exports = __webpack_public_path__ + "static/media/ag-shop2.30ae2cc3.jpg";